/*! xtend-magento (https://getxtend.com/)
@copyright (c) 2017 - 2018 Riccardo Caroli
@license MIT (https://github.com/minimit/xtend-library/blob/master/LICENSE) */

//////////////////////
// #newsletter-cats
//////////////////////

function initNewsletterCats(added) {
  let btns = added.querySelectorAll('#newsletter-cat-cats .btn');
  if (btns.length) {
    // vars
    let btnAll = added.querySelectorAll('#newsletter-cat-all');
    let inputArr = [];
    let inputAll = added.querySelectorAll('#newsletter-cats')[0];
    // set value
    let changeNewsletterCat = function () {
      inputAll.value = inputArr.join(', ');
      console.log('newsletter values:', inputAll.value);
    };
    // events
    for (let [i, btn] of btns.entries()) {
      btn.addEventListener('on', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr.push(btn.getAttribute('data-value'));
          changeNewsletterCat();
          if (btnAll.length) {
            btnAll[0].dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
        }
      });
      btn.addEventListener('off', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = inputArr.filter(function (value) {
            return value !== btn.getAttribute('data-value');
          });
          changeNewsletterCat();
          if (btnAll.length) {
            btnAll[0].dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
        }
      });
    }
    if (btnAll.length) {
      btnAll[0].addEventListener('on', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = [];
          for (let [i, btn] of btns.entries()) {
            inputArr.push(btn.getAttribute('data-value'));
            btn.dispatchEvent(new CustomEvent('on', {detail: {skipToggle: true}}));
          }
          changeNewsletterCat();
        }
      });
      btnAll[0].addEventListener('off', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = [];
          for (let [i, btn] of btns.entries()) {
            btn.dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
          changeNewsletterCat();
        }
      });
    }
  }
}

initNewsletterCats(document);

//////////////////////
